// extracted by mini-css-extract-plugin
export default {"container":"VerifyEmailPage_container__ACGlc","content":"VerifyEmailPage_content__LHve5","errorText":"VerifyEmailPage_errorText__HaQ8A","button":"VerifyEmailPage_button__8qxE-"};